import { FontSizes, Text } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/reducers';
import { DEFAULT_THEME_MODE } from '../../theme/guideTokens';
import { FOOTER_LOGO_DARK, FOOTER_LOGO_LIGHT } from './footerLogo';

export const FooterBarComponent = () => {
  const mode = useSelector((state: AppState) => state.Theme?.mode ?? DEFAULT_THEME_MODE);
  const isLight = mode === 'light';
  // Oscuro / alto contraste: logo propio si está; si no, el claro (fondo transparente) aclarado por CSS.
  const src = !isLight && FOOTER_LOGO_DARK ? FOOTER_LOGO_DARK : FOOTER_LOGO_LIGHT;
  const adapted = !isLight && !FOOTER_LOGO_DARK;

  return (
    <div className="footerBar">
      <Text style={{ color: 'var(--ichtys-text-secondary)', fontSize: FontSizes.size16 }}>©2023</Text>
      <a href="https://www.ichtys.com.ar/" target="_blank" rel="noopener noreferrer">
        <img
          height={40}
          style={{ marginTop: 3 }}
          className={adapted ? 'footerLogo footerLogoAdapted' : 'footerLogo'}
          src={src}
          alt="Ichtys Technology"
        />
      </a>
    </div>
  );
};
